const Footer = () => {
    return (
        <footer className="main-footer">
            <strong>Copyright &copy; 2022 <a href="https://muttotarjous.fi">Muttotarjous.fi</a>.</strong> All rights reserved.
        </footer>
    )
}

export default Footer;